<template>
  <div>
    <OInput
      v-model="dateComplete"
      :size="Screen.lt.md ? 'md' : 'lg'"
      :label="label"
      v-bind="attrs"
      class="bg-white dark:!bg-d-neutral-20 dark:!bg-transparent w-full cursor-pointer label-transparent"
    >
      <q-popup-proxy
        ref="popUpDate"
        transition-show="scale"
        transition-hide="scale"
        class="!min-w-max"
      >
        <q-date
          v-model="model.data"
          today-btn
          :title="model.data ? '' : label"
        >
          <div class="flex flex-col w-full">
            <OInput
              v-if="hasTime"
              v-model="model.hora"
              size="md"
              type="time"
              class="label-transparent"
            />
            <OButton
              size="md"
              tertiary
              class="mt-8 ml-auto -mb-8 !min-w-full"
              @click="popUpDate.hide()"
            >
              {{ t('confirm') }}
            </OButton>
          </div>
        </q-date>
      </q-popup-proxy>

      <template #append>
        <q-icon :name="icon" class="cursor-pointer" />
      </template>
    </OInput>
  </div>
</template>

<script setup>
import { computed, ref, useAttrs, watch } from 'vue'
import { date, Screen } from 'quasar'
import { FData } from 'utils/GLOBAL'
import { useI18n } from 'vue-i18n'
import { useRefHistory } from '@vueuse/core'
import OButton from 'components/Button/OButton.vue'
import OInput from 'components/Input/OInput.vue'

const { t } = useI18n()

const attrs = useAttrs()

const props = defineProps({
  data: { type: String, default: '' },
  label: { type: String, default: '' },
  icon: {
    type: String,
    default: 'svguse:#icon_date',
  },
  hasTime: { type: Boolean, default: false },
})

const emit = defineEmits(['update:date'])

const popUpDate = ref(Element)

const dateComplete = computed(() => {
  if (model.value.data && model.value.hora && props.hasTime) {
    return model.value.data
      ? `${FData(model.value.data)} - ${model.value.hora}`
      : null
  }
  return model.value.data ? `${FData(model.value.data)}` : null
})

const initialDate = computed(() => {
  const prop = props.data
  const myDate = FData(prop, 'YYYY/MM/DD')
  const result = prop ? myDate : null
  return result
})

const initialTime = computed(() => {
  const prop = props.data
  return prop ? date.formatDate(prop, 'HH[:]mm') : '12:00'
})

const model = ref({
  data: initialDate.value,
  hora: initialTime.value,
})

const history = useRefHistory(model, {
  capacity: 1,
  deep: true,
  flush: 'sync',
})

watch(
  () => [model.value.data, model.value.hora],
  ([data, hora]) => {
    if (!props.hasTime) {
      const dataFinal = FData(data, 'YYYY-MM-DD')
      emit('update:date', dataFinal)
      return
    }
    const dateTime = new Date(`${data} ${hora}`)
    const dataFinal = date?.formatDate(dateTime)
    emit('update:date', dataFinal)
  }
)

defineExpose({ history })
</script>

<style lang="scss" scoped></style>
